<template>
  <div id="application-rules__action" class="ma-2">
    <v-btn
      color="primary"
      id="application-rules__open-dialog"
      class="mb-2"
      @click="openDialog()"
      :disabled="!isPermitted(PermissionEnum.APPLICATION_RULES.ADD)"
      >{{ $t("modules.dataPath.add") }}</v-btn
    >
    <v-dialog
      v-model="dialog"
      v-if="
        isPermitted(PermissionEnum.APPLICATION_RULES.ADD) ||
          isPermitted(PermissionEnum.APPLICATION_RULES.UPDATE)
      "
      fullscreen
      transition="dialog-bottom-transition"
      persistent
      id="application-rules__dialog"
    >
      <v-card id="application-rules__form-card">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="save()"
          id="application-rules__form"
        >
          <v-app-bar dark color="primary" fixed>
            <v-toolbar-title id="application-rules__form-title">{{
              formTitle
            }}</v-toolbar-title>
          </v-app-bar>

          <v-card-text class="pt-12 mt-12" id="application-rules__form-card">
            <v-container id="application-rules__form-container">
              <v-layout class="flex-column">
                <div
                  class="d-flex align-center"
                  id="application-rules__form-fields"
                >
                  <v-flex xs8 sm10 md6>
                    <v-text-field
                      v-model="name"
                      :label="$t('modules.dataPath.name')"
                      id="application-rules__form-name"
                      :rules="[
                        v =>
                          !!v ||
                          $t('validation.required', [
                            $t('modules.dataPath.name')
                          ])
                      ]"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm2 md2>
                    <v-checkbox
                      color="primary"
                      v-model="isEnabled"
                      :label="$t('modules.dataPath.enabled')"
                      id="application-rules__form-enabled"
                    ></v-checkbox>
                  </v-flex>
                </div>
                <div>
                  <v-flex xs12 sm12 md4 v-if="false">
                    <v-layout>
                      <v-flex>
                        <v-switch
                          color="primary"
                          v-model="bandwidth_limit_toggle"
                          :label="$t('modules.dataPath.bandwidthLimit')"
                          id="application-rules__form-bandwidth-limit-check"
                        ></v-switch>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          id="application-rules__form-bandwidth-limit-value"
                          v-if="bandwidth_limit_toggle"
                          v-model="bandwidth_limit"
                          hide-details
                        >
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </div>
                <div>
                  <v-flex xs12 sm12 md6>
                    <v-select
                      type="button"
                      v-model="vpnProfileId"
                      :items="vpnProfiles"
                      :label="$t('modules.dataPath.vpnProfile')"
                      id="application-rules__form-vpn-profile"
                      item-text="name"
                      item-value="id"
                      :rules="[
                        v =>
                          (v !== null && v !== undefined) ||
                          $t('validation.required', [
                            $t('modules.dataPath.vpnProfile')
                          ])
                      ]"
                      clearable
                    >
                      <template v-slot:selection="{ item }">
                        <span v-if="item.is_enabled === false"
                          >{{ item.name }}
                          <span class="red--text">
                            (
                            {{ $t("modules.dataPath.notEnabledText") }} )</span
                          >
                        </span>
                        <span v-else>
                          {{ item.name }}
                        </span>
                      </template>
                    </v-select>
                  </v-flex>
                </div>
                <div v-if="vpnProfileId">
                  <v-flex xs12 sm12 md6 class="elevation-2 mx-1 pa-3 my-2">
                    <div v-if="vpnProfileId === 'No VPN/Custom'">
                      <div class="subheading font-weight-bold">
                        {{ $t("modules.dataPath.hostEndpoint") }}
                      </div>
                      <v-text-field
                        v-model="hostPort"
                        type="number"
                        :label="$t('modules.dataPath.hostPort')"
                        id="application-rules__form-host-port"
                        :rules="[
                          v =>
                            !!v ||
                            $t('validation.required', [
                              $t('modules.dataPath.hostPort')
                            ])
                        ]"
                      ></v-text-field>
                    </div>
                    <application-rules-hosts></application-rules-hosts>
                  </v-flex>
                  <v-flex xs12 sm12 md6 class="elevation-2 mx-1 pa-3 mt-6">
                    <div v-if="vpnProfileId === 'No VPN/Custom'">
                      <div class="subheading font-weight-bold">
                        {{ $t("modules.dataPath.hubEndpoint") }}
                      </div>
                      <v-text-field
                        v-model="hubPort"
                        type="number"
                        :label="$t('modules.dataPath.hubPort')"
                        id="application-rules__form-hub-port"
                        :rules="[
                          v =>
                            !!v ||
                            $t('validation.required', [
                              $t('modules.dataPath.hubPort')
                            ])
                        ]"
                      ></v-text-field>
                      <v-text-field
                        v-model="hubIP"
                        :label="$t('modules.dataPath.hubIP')"
                        id="application-rules__form-hub-ip"
                        :rules="ipRules"
                      ></v-text-field>
                    </div>
                    <application-rules-hubs></application-rules-hubs>
                  </v-flex>
                </div>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions id="application-rules__form-actions">
            <v-container id="application-rules__form-actions-container">
              <v-flex xs12 sm12 md6 class="d-flex justify-end">
                <v-btn
                  color="secondary"
                  elevation="1"
                  @click="close"
                  id="application-rules__cancel"
                >
                  {{ $t("actions.cancel") }}
                </v-btn>
                <v-btn
                  color="secondary"
                  type="submit"
                  :loading="is_loading"
                  :disabled="is_loading_global"
                  id="application-rules__save"
                  class="ml-3"
                  v-if="vpnProfileId"
                  >{{
                    editedIndex === -1 ? $t("actions.add") : $t("actions.save")
                  }}</v-btn
                >
              </v-flex>
            </v-container>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApplicationRulesHosts from "./application-rules-hosts";
import ApplicationRulesHubs from "./application-rules-hubs";
import { mapState } from "vuex";
import { handleError } from "@/utils/error";
import { permissionMixin } from "@/mixins/permissions";

export default {
  name: "ApplicationRuleAction",
  components: { ApplicationRulesHubs, ApplicationRulesHosts },
  mixins: [permissionMixin],
  data() {
    return {
      searchInput: "",
      valid: false,
      bandwidth_limit_toggle: false,
      bandwidth_limit: 0,
      hosts: [],
      ipRules: [
        v =>
          !!v ||
          this.$t("validation.required", [this.$t("modules.dataPath.hubIP")]),
        v => {
          let IP_PATTERN = /^(?!\.)((^|\.)([1-9]?\d|1\d\d|2(5[0-5]|[0-4]\d))){4}$/gm;
          return (
            IP_PATTERN.test(v) ||
            this.$t("validation.invalid", [this.$t("modules.dataPath.hubIP")])
          );
        }
      ]
    };
  },
  computed: {
    applicationRules() {
      return this.$store.state.dataPath.applicationRules;
    },
    vpnProfiles() {
      let vpn_profiles = this.$store.state.dataPath.vpnProfile.vpnProfiles;
      let customList = [{ id: "No VPN/Custom", name: "No VPN/Custom" }];
      let profiles = [...customList, ...vpn_profiles];
      return profiles;
    },
    dialog: {
      get() {
        return this.$store.state.dataPath.dialog;
      },
      set(val) {
        this.$store.dispatch("dataPath/toggleDialog", val);
      }
    },
    formTitle() {
      return this.$store.state.dataPath.formTitle;
    },
    editedItem() {
      return this.$store.state.dataPath.editedItem;
    },
    editedIndex() {
      return this.$store.state.dataPath.editedIndex;
    },
    name: {
      get() {
        return this.$store.state.dataPath.editedItem.name;
      },
      set(val) {
        this.$store.commit("dataPath/updateName", val);
      }
    },
    vpnProfileId: {
      get() {
        return this.$store.state.dataPath.editedItem.vpnProfileId;
      },
      set(val) {
        this.$store.commit("dataPath/updateVpnProfileId", val);
      }
    },

    isEnabled: {
      get() {
        return this.$store.state.dataPath.editedItem.isEnabled;
      },
      set(val) {
        this.$store.commit("dataPath/updateIsEnabled", val);
      }
    },

    hostPort: {
      get() {
        return this.$store.state.dataPath.editedItem.hostPort;
      },
      set(val) {
        this.$store.commit("dataPath/updateHostPort", val);
      }
    },

    hubPort: {
      get() {
        return this.$store.state.dataPath.editedItem.hubPort;
      },
      set(val) {
        this.$store.commit("dataPath/updateHubPort", val);
      }
    },

    hubIP: {
      get() {
        return this.$store.state.dataPath.editedItem.hubIP;
      },
      set(val) {
        this.$store.commit("dataPath/updateHubIP", val);
      }
    },

    hostRedundancyLevel: {
      get() {
        return this.$store.state.dataPath.editedItem.hostRedundancyLevel;
      },
      set(val) {
        this.$store.commit("dataPath/updateHostRedundancyLevel", val);
      }
    },

    hostRedundancyPercentage: {
      get() {
        return this.$store.state.dataPath.editedItem.hostRedundancyPercentage;
      },
      set(val) {
        this.$store.commit("dataPath/updateHostRedundancyPercentage", val);
      }
    },

    hubRedundancyLevel: {
      get() {
        return this.$store.state.dataPath.editedItem.hubRedundancyLevel;
      },
      set(val) {
        this.$store.commit("dataPath/updateHubRedundancyLevel", val);
      }
    },

    hubRedundancyPercentage: {
      get() {
        return this.$store.state.dataPath.editedItem.hubRedundancyPercentage;
      },
      set(val) {
        this.$store.commit("dataPath/updateHubRedundancyPercentage", val);
      }
    },

    hostReorder: {
      get() {
        return this.$store.state.dataPath.editedItem.hostReorder;
      },
      set(val) {
        this.$store.commit("dataPath/updateHostReorder", val);
      }
    },

    hubReorder: {
      get() {
        return this.$store.state.dataPath.editedItem.hubReorder;
      },
      set(val) {
        this.$store.commit("dataPath/updateHubReorder", val);
      }
    },

    search: {
      get() {
        return this.$store.state.dataPath.search;
      },
      set(val) {
        this.$store.commit("dataPath/updateSearch", val);
      }
    },

    is_loading() {
      return this.$store.state.loader.is_loading;
    },
    is_loading_global() {
      return this.$store.state.loader.is_loading_global;
    },

    ...mapState("dataPath", {
      primaryHub: state => state.editedItem.primaryHub,
      secondaryHub: state => state.editedItem.secondaryHub,
      tertiaryHub: state => state.editedItem.tertiaryHub
    })
  },

  methods: {
    openDialog() {
      this.$store.commit("dataPath/updateIndex", -1);
      this.$store.commit("dataPath/updateFormTitle", 1);
      this.$store.dispatch("dataPath/toggleDialog", true);
    },

    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("loader/startLoading");
        if (this.editedIndex > -1) {
          let data = {
            id: this.applicationRules[this.editedIndex].id,
            name: this.name,
            vpnProfileId: this.vpnProfileId,
            isEnabled: this.isEnabled,
            hostRedundancyLevel: this.hostRedundancyLevel,
            hostRedundancyPercentage: this.hostRedundancyPercentage,
            hubRedundancyLevel: this.hubRedundancyLevel,
            hubRedundancyPercentage: this.hubRedundancyPercentage,
            hostReorder: this.hostReorder,
            hubReorder: this.hubReorder,
            hostPort: this.hostPort,
            hubPort: this.hubPort,
            hubIP: this.hubIP,
            primaryHub: this.primaryHub,
            secondaryHub: this.secondaryHub,
            tertiaryHub: this.tertiaryHub
          };
          this.$store.dispatch("dataPath/update", data).catch(error => {
            handleError(error);
          });
        } else {
          let data = {
            name: this.name,
            vpnProfileId: this.vpnProfileId,
            isEnabled: this.isEnabled,
            hostRedundancyLevel: this.hostRedundancyLevel,
            hostRedundancyPercentage: this.hostRedundancyPercentage,
            hubRedundancyLevel: this.hubRedundancyLevel,
            hubRedundancyPercentage: this.hubRedundancyPercentage,
            hostReorder: this.hostReorder,
            hubReorder: this.hubReorder,
            hostPort: this.hostPort,
            hubPort: this.hubPort,
            hubIP: this.hubIP,
            primaryHub: this.primaryHub,
            secondaryHub: this.secondaryHub,
            tertiaryHub: this.tertiaryHub
          };
          this.$store.dispatch("dataPath/add", data).catch(error => {
            handleError(error);
          });
        }
      }
    },

    close() {
      this.$store.dispatch("dataPath/toggleDialog", false).then(response => {
        this.$refs.form.resetValidation();
        this.$store.dispatch("dataPath/clearForm");
        this.$store.commit("dataPath/updateIndex", -1);
      });
    }
  }
};
</script>

<style></style>
